import { CHANGE_BUSINESSNAME } from "../actions/types";

const initialState = [""];
export default function(state = initialState, action) {
  let businessName;

  switch (action.type) {
    case CHANGE_BUSINESSNAME:
      var { index, value } = action.payload;
      businessName = [...state];
      //TODO: Business name is not an array
      businessName[index] = value;
      return businessName;
    default:
      return state;
  }
}
